import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertifyService } from '../../../services/alertify.service';
import { clone } from '../../extensions';
import { FieldComponent } from '../field/field.component';

@Component({
  selector: 'ig-multi-fields',
  templateUrl: './multiple.fields.component.html',
  styleUrls: ['./multiple.fields.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MultipleFieldsComponent implements OnInit {
  public text: string;
  public form: FormGroup;
  public filteredItems: string[] = [];
  @Input() public group: string[] = [];
  @Input() public limit = 0;
  @Input() public filterText = [];
  @Input() public autoCompleteSource: string[] = [];
  @Input() public label = 'e.g., https://www.facebook.com/pg/msmuseumart/events/';
  @ViewChild('autocomplete') public autocomplete: ElementRef;
  @ViewChild('field') public field: FieldComponent;
  @Output() onAdd: EventEmitter<string> = new EventEmitter<string>();
  @Output() onRemove: EventEmitter<any> = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder, private alertify: AlertifyService) {}

  public ngOnInit() {
    this.form = this.formBuilder.group({
      text: [null],
    });

    this.removeExistingFromAutoComplete();
    if (this.autoCompleteSource.length > 0) {
      this.form.get('text').valueChanges.subscribe((value) => {
        if (this.text) {
          this.filteredItems = this.autoCompleteSource.filter((item) =>
            item.toLowerCase().includes(this.text.toLowerCase())
          );
          setTimeout(() => {
            if (this.field && this.field.input) {
              let rect = this.field.input.nativeElement.getBoundingClientRect();
              if (this.autocomplete) {
                this.autocomplete.nativeElement.style.top = `${rect.top + rect.height + 2}px`;
                this.autocomplete.nativeElement.style.left = `${rect.left}px`;
                this.autocomplete.nativeElement.style.width = `${rect.width}px`;
                this.autocomplete.nativeElement.style.display = 'block';
              }
            }
          });
        } else {
          this.filteredItems = [];
        }
      });
    }
  }

  public select(item: string) {
    this.text = item;
    this.filteredItems = [];
    setTimeout(() => {
      this.autocomplete.nativeElement.style.display = 'none';
    }, 10);
  }

  public add() {
    if (!this.text) return;

    if (this.limit && this.group.length >= this.limit) {
      this.alertify.warning('The number of items you have added has exceeded the limit');
    } else {
      if (this.filterText && this.filterText.length > 0) {
        console.log('enter filteing');

        this.text = this.text.replace(new RegExp(this.filterText.join('|'), 'gi'), '');
        console.log(this.text);
      }
      this.group.push(clone(this.text));
      this.onAdd.emit(clone(this.text));
      this.text = '';
      this.removeExistingFromAutoComplete();
    }
  }

  public removeExistingFromAutoComplete() {
    // keep the items that are not in the autoCompleteSource
    this.autoCompleteSource = this.autoCompleteSource.filter(
      (item) => this.group.indexOf(item) < 0
    );
  }

  public remove(index: number, item: any) {
    this.group.splice(index, 1);
    this.onRemove.emit({
      index,
      item,
    });
  }

  public getText() {
    return this.text;
  }

  public setText(text: string) {
    this.text = text;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/multiple.fields/multiple.fields.component.ts